// extracted by mini-css-extract-plugin
export var quantityInput = "_gp-0";